import React from "react";
import { Box } from "@mui/material";
import {
  HeroSection,
  AIFeaturesSection,
  FeaturesSection,
  ScreenshotsSection,
  VideoSection,
  PricingSection,
  FooterSection,
} from "../components/landing";
import SEO from "../components/SEO";

// Structured data for landing page
const landingStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "ThinkWay - Planejamento Estratégico com Inteligência Artificial",
  "description": "Plataforma de planejamento estratégico empresarial com IA. Defina metas, crie planos de ação, faça análise SWOT e acompanhe resultados em tempo real.",
  "url": "https://thinkway.app",
  "mainEntity": {
    "@type": "SoftwareApplication",
    "name": "ThinkWay",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "0",
      "highPrice": "149.90",
      "priceCurrency": "BRL",
      "offerCount": "3"
    }
  }
};

const LandingPage: React.FC = () => {
  return (
    <>
      <SEO 
        description="ThinkWay é a plataforma de planejamento estratégico empresarial com IA. Defina metas, crie planos de ação, faça análise SWOT e acompanhe resultados em tempo real. Teste grátis por 7 dias."
        url="https://thinkway.app"
        structuredData={landingStructuredData}
      />
      <Box sx={{ overflowX: "hidden" }}>
        <HeroSection />
        <AIFeaturesSection />
        <FeaturesSection />
        <ScreenshotsSection />
        <VideoSection />
        <PricingSection />
        <FooterSection />
      </Box>
    </>
  );
};

export default LandingPage;
